var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-header navbar navbar-fixed-top" }, [
    _c(
      "div",
      { staticClass: "page-logo" },
      [
        _c("router-link", { attrs: { to: { name: "home" } } }, [
          _c("img", {
            staticClass: "logo-default cap",
            attrs: {
              src: "/static/front/images/menu-images/b1g1-logo.svg",
              alt: "alt"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "menu-toggler sidebar-toggler" })
      ],
      1
    ),
    _vm._v(" "),
    _c("a", {
      staticClass: "menu-toggler responsive-toggler",
      attrs: {
        href: "javascript:void(0);",
        "data-toggle": "collapse",
        "data-target": ".navbar-collapse"
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "page-header-inner" }, [
        _c("div", { staticClass: "page-top" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "top-menu" }, [
            _c("ul", { staticClass: "nav navbar-nav pull-right" }, [
              !_vm.isAdminLogin
                ? _c("li", { staticClass: "dropdown dropdown-user" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle",
                        attrs: { href: "#", "data-toggle": "dropdown" },
                        on: {
                          click: function($event) {
                            _vm.showDropDown = !_vm.showDropDown
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "profilePic" }, [
                          _vm._v(_vm._s(_vm.wcName.charAt(0)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "username username-hide-on-mobile" },
                          [
                            _c("span", [_vm._v("Welcome,")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.wcName.length > 20
                                    ? _vm.wcName.substr(0, 20) + "..."
                                    : _vm.wcName
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showDropDown
                      ? _c("ul", { staticClass: "dropdown-menu" }, [
                          _c("li", [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-toggle",
                                on: { click: _vm.logout }
                              },
                              [_vm._m(2)]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isAdminLogin
                ? _c("li", { staticClass: "dropdown dropdown-user" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle",
                        attrs: { href: "#", "data-toggle": "dropdown" }
                      },
                      [
                        _c("span", { staticClass: "profilePic" }, [
                          _vm._v(_vm._s(_vm.wcName.charAt(0)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "username username-hide-on-mobile" },
                          [
                            _c("span", [_vm._v("Welcome,")]),
                            _vm._v(
                              _vm._s(
                                _vm.wcName.length > 20
                                  ? _vm.wcName.substr(0, 20) + "..."
                                  : _vm.wcName
                              ) + "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(3)
                      ]
                    ),
                    _vm._v(" "),
                    _c("ul", { staticClass: "dropdown-menu" }, [
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.adminAccount()
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/front/images/drop-down-icon/admin-account.svg",
                                alt: ""
                              }
                            }),
                            _vm._v("Admin Account")
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle",
                            on: { click: _vm.logout }
                          },
                          [_vm._m(4)]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "form",
      {
        staticClass: "search-form search-form-expanded",
        attrs: { action: "extra_search.html", method: "GET" }
      },
      [
        _c(
          "h2",
          {
            staticStyle: {
              "font-size": "26px",
              "font-weight": "500",
              color: "#000000",
              "margin-left": "0px"
            }
          },
          [_vm._v("Worthy Cause User Panel")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "caret" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/down-arrow.svg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "username username-hide-on-mobile" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/drop-down-icon/log-out.svg",
          alt: ""
        }
      }),
      _vm._v("Logout ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "caret" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/down-arrow.svg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "username username-hide-on-mobile" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/drop-down-icon/log-out.svg",
          alt: ""
        }
      }),
      _vm._v("Logout ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2dbac38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2dbac38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/Header.vue
// module id = null
// module chunks = 